import Segment from '../shared/segment';

function EduSubGroupsTitle() {
  return (
    <Segment>
      <h1 className='mb-2 text-center text-lg font-medium'>توضیحات زیر‌گروه‌ها و ضرایب</h1>
    </Segment>
  );
}

export default EduSubGroupsTitle;
